import { useCallback, useEffect, useState } from "react";
import httpClient from "../../utilis/jwtRequest";
import BErrorIndicator from "../indicators/BErrorIndicator";
import BLoadingIndicator from "../indicators/BLoadingIndicator";
import BNoDataIndicator from "../indicators/BNoDataIndicator";
import BTable from "../tables/BTable";
import { ORDER_WAY } from "../constants/componentsConstants";

function BResourcePage({
  url,
  title,
  isCustomerPage,
  preloadedData,
  aboveTableComponent,
  isReadOnly,
  maxNmbOfChars,
  fieldsVisibleAtBeginning,
}) {
  const [pageSize, setPageSize] = useState(20);
  const [nmbOfRecords, setNmbOfRecords] = useState(20);
  const [page, setPage] = useState(1);
  const [resources, setResources] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [ordering, setOrdering] = useState([]);
  const [availableWidth, setAvailableWidth] = useState(0);
  const availableOptions = [10, 15, 20, 40];
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    if (preloadedData != null) {
      setResources(preloadedData);
      console.log(preloadedData);
      return;
    }

    if (!url) return;

    setIsLoading(true);
    setError(false);
    httpClient
      .get(url)
      .then((res) => {
        if (!Array.isArray(res.data)) {
          res.data = [res.data];
        }
        setResources(res.data);
        setNmbOfRecords(res.data.count);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, [url, page, pageSize, ordering]);

  const formatUrl = () => {
    const order = ordering.join();
    return `${url}?page_size=${pageSize}&page=${page}&ordering=${order}`;
  };

  const child = useCallback((node) => {
    if (node !== null) {
      setAvailableWidth(node.getBoundingClientRect().width);
    }
  });

  const addOrdering = (field) => {
    let tempOrdering = [...ordering];
    field = field.replace(/([A-Z])/g, "_$1").toLowerCase();
    let orderState;

    if (tempOrdering.includes(field)) {
      const idx = tempOrdering.indexOf(field);
      tempOrdering[idx] = `-${field}`;
      orderState = ORDER_WAY.decrease;
    } else if (tempOrdering.includes(`-${field}`)) {
      const idx = tempOrdering.indexOf(`-${field}`);
      tempOrdering.splice(idx, 1);
      orderState = ORDER_WAY.default;
    } else {
      tempOrdering.push(field);
      orderState = ORDER_WAY.increase;
    }
    setOrdering(tempOrdering);
    setPage(1);
    return orderState;
  };

  if (isLoading) {
    return <BLoadingIndicator />;
  } else if (error) {
    return <BErrorIndicator />;
  }

  if (noData) {
    return <BNoDataIndicator />;
  }

  return (
    <div ref={child} className="p-6">
      <BTable
        data={resources}
        header={title}
        availableOptions={availableOptions}
        setPageSize={setPageSize}
        pageSize={pageSize}
        addOrdering={addOrdering}
        title={url}
        ordering={ordering}
        availableWidth={availableWidth}
        isCustomerPage={isCustomerPage}
        maxNmbOfChars={maxNmbOfChars}
        aboveTableComponent={aboveTableComponent}
        isReadOnly={isReadOnly}
        fieldsVisibleAtBeginning={fieldsVisibleAtBeginning}
      />
    </div>
  );
}

export default BResourcePage;
